import React from "react"
import PropTypes from "prop-types"

import {
  Navigation,
  SelectField,
  NavigationListLink,
  IconLabel,
  Profile,
  ProfilePresenter
} from "~/components/"
import {
  LanguageSwitch,
  TenantNavigationList,
  ShoppingCart
} from "~/components/navigations"
import {useTranslation} from "react-i18next"

const packageJson = require("../../../package.json")

const signOutIcon = require("~/icons/sign_out_16_white.svg")
const teamIcon = require("~/icons/team_16_white.svg")
const settingsIcon = require("~/icons/settings_16_white.svg")

const UserNavigation = ({user, logout}) => {
  const {t} = useTranslation()
  const tenantsAdmin = user.admin || user.tenantAdmin || user.superAdmin

  const renderConditionalNavigationItems = (
    <React.Fragment>{user.mayUseCart && <ShoppingCart />}</React.Fragment>
  )

  return (
    <Navigation>
      <div
        style={{
          overflow: "auto",
          display: "flex",
          flexFlow: "column",
          flex: 1
        }}
      >
        {/* {user.superAdmin ? (
          <SuperAdminNavigationList>
            {renderConditionalNavigationItems}
          </SuperAdminNavigationList>
        ) : (
          <TenantNavigationList>
            {renderConditionalNavigationItems}
          </TenantNavigationList>
        )} */}
        <TenantNavigationList>
          {renderConditionalNavigationItems}
        </TenantNavigationList>
        <div
          className="sh-navigation-list"
          style={{display: "flex", flexFlow: "column"}}
        >
          <div className="item" style={{}}>
            {tenantsAdmin && (
              <React.Fragment>
                <NavigationListLink to="/users/" icon={teamIcon}>
                  {t("navigationItems.users")}
                </NavigationListLink>

                <NavigationListLink
                  to={"/settings/" + user.subdomain}
                  icon={settingsIcon}
                >
                  {t("navigationItems.settings")}
                </NavigationListLink>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>

      <Profile name={user.subdomain} style={{height: "auto"}}>
        <ProfilePresenter
          uid={user.uid}
          subdomain={user.subdomain}
          companyName={user.settings.companyName}
          debitorNumber={user.settings.debitorNumber}
        >
          <a href="/signout" onClick={logout}>
            <IconLabel i={signOutIcon}>{t("navigationItems.logout")}</IconLabel>
          </a>
          <LanguageSwitch />
          <div
            style={{
              display: "flex",
              flexFlow: "row",
              marginTop: 20,
              alignContent: "center",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <div>
              <p style={{fontSize: "0.8em"}}>Version {packageJson.version}</p>
            </div>
          </div>
        </ProfilePresenter>
      </Profile>
    </Navigation>
  )
}

UserNavigation.propTypes = {
  user: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired
}

export default UserNavigation



// WEBPACK FOOTER //
// ./src/components/navigations/UserNavigation.js